const storefinder = {
  mapDiv: document.getElementById("map") as HTMLElement,
  map: null as google.maps.Map | null,
  markers: (window as any).markerJSON as { [key: string]: string }[],
  filterdMarkers: (window as any).markerJSON as { [key: string]: string }[],
  searchDiv: document.getElementById("mapSearch") as HTMLInputElement,
  storesHTML: document.getElementById("stores") as HTMLElement,
  impStoresHTML: document.getElementById("impStores") as HTMLElement,
  impMarkers: [] as { [key: string]: string }[],
  regularMarkers: [] as { [key: string]: string }[],
  brands: (window as any).brandsJSON as { [key: string]: string }[],
  services: (window as any).servicesJSON as { [key: string]: string }[],
  show: document.getElementById("showMap") as HTMLElement,
  hide: document.getElementById("hideMap") as HTMLElement,
  mapSection: document.getElementById("mapSection") as HTMLElement | undefined,
  button: document.getElementById("mapSearchBtn") as HTMLElement | undefined,
  servicesListWrap: document.getElementById("brandsList") as HTMLElement | undefined,
  currentCenter: null as google.maps.LatLng | null,
  selectedServices: [] as string[],
  radius: 30,
  mapMarkers: [] as google.maps.Marker[],
  infoWindows: [] as google.maps.InfoWindow[],
  init() {
    if (this.mapSection) {
      this.setMap()
      this.search()
      this.showHideMap()
      this.btnSearch()
      this.setServices()
      this.setServicesFilter()
      this.setMapClick()
    }
  },
  setServices() {
    if (this.servicesListWrap) {
      let html = ""
      this.services.forEach((item) => {
        html += `<li class="google-search__brand-item jsServices" data-id="${item.id}" data-active="false">
                <div class="google-search__squer">
                  <svg class="" target="_blank">
                    <use xlink:href="#check-regular"></use>
                  </svg>
                </div>
               <span class="main-text"> ${item.name}</span>
            </li>`
      })
      this.servicesListWrap.innerHTML = html
    }
  },
  setServicesFilter() {
    const servicesCheck = this.servicesListWrap?.querySelectorAll(".jsServices") as NodeListOf<HTMLElement>
    servicesCheck.forEach((item) => {
      item.addEventListener("click", () => {
        const id = item.dataset.id as string
        if (item.dataset.active === "false") {
          item.classList.add("activeClass")
          item.dataset.active = "true"
          this.setSelectedServices(id)
        } else {
          item.classList.remove("activeClass")
          item.dataset.active = "false"
          this.setSelectedServices(id)
        }
      })
    })
  },
  setSelectedServices(id: string) {
    if (this.selectedServices.includes(id)) {
      this.selectedServices = this.selectedServices.filter((item) => item !== id)
    } else {
      this.selectedServices.push(id)
    }
    this.sortMarkers(this.currentCenter as google.maps.LatLng, this.radius)
  },
  showHideMap() {
    this.show.addEventListener("click", () => {
      this.mapSection?.classList.remove("d-none")
    })
    this.hide.addEventListener("click", () => {
      this.mapSection?.classList.add("d-none")
    })
  },
  btnSearch() {
    this.button?.addEventListener("click", () => {
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ address: this.searchDiv.value }).then((res) => {
        const results = res.results[0]
        const lat = results.geometry?.location?.lat()
        const lng = results.geometry?.location?.lng()

        if (lat && lng) {
          const current = new google.maps.LatLng(lat, lng)
          this.sortMarkers(current, this.radius)
        }
      })
    })
  },
  setMap() {
    const center: google.maps.LatLngLiteral = { lat: -21.8889561, lng: 124.8740994 }
    this.map = new google.maps.Map(this.mapDiv, {
      center,
      zoom: 4,
    })
  },
  clearMarkers() {
    this.mapMarkers.forEach((item) => {
      item.setMap(null)
    })
  },
  closeInfoWindows() {
    this.infoWindows.forEach((item) => item.close())
  },
  setMapClick(){
    if(this.map){
      google.maps.event.addListener(this.map, "click", () => {
        this.closeInfoWindows()
      })
    }
  
  },  
  setCenter() {
    if (this.map) {
      this.clearMarkers()
      const bounds = new google.maps.LatLngBounds()
      this.filterdMarkers.forEach((item) => {
        const location = new google.maps.LatLng(+item.lat, +item.lng)
        const marker = new google.maps.Marker({
          position: location,
          map: this.map,
        })
        const infoWindow = new google.maps.InfoWindow({
          content: `<h5 class="m-0">${item.name}</h5></br> ${item.street1 ? item.street1 + "," : ""} ${item.street2 ? item.street2 + "," : ""} ${item.city}  ${item.state}</br>${item.zip}<br>  </br><a href="tel:${item.phone}">${item.phone}</a>`,
        })
        this.infoWindows.push(infoWindow)
        google.maps.event.addListener(marker, "click", () => {
          this.closeInfoWindows()
          infoWindow.open(this.map, marker)
        })
        bounds.extend(location)
        this.mapMarkers.push(marker)
      })
      this.map.fitBounds(bounds)
    }
  },
  sortMarkers(center: google.maps.LatLng, dist: number) {
    this.filterdMarkers = this.markers
      .filter((item) => {
        const marker = new google.maps.LatLng(+item.lat, +item.lng)
        const services = item.services.split(",")
        item.distance = (google.maps.geometry.spherical.computeDistanceBetween(center, marker) / 1000).toFixed(2)

        if (this.selectedServices.length) {
          if (+item.distance < dist && this.selectedServices.some((el) => services.includes(el))) {
            return item
          }
        } else {
          if (+item.distance < dist) {
            return item
          }
        }
      })
      .sort((a, b) => +a.distance - +b.distance)
      .slice(0, 8)
    this.impMarkers = this.filterdMarkers.filter((item) => item.highPr === "y")
    this.regularMarkers = this.filterdMarkers.filter((item) => item.highPr !== "y")
    this.setHtml()

    this.setCenter()
  },
  search() {
    const autocomplete = new google.maps.places.Autocomplete(this.searchDiv, {
      fields: ["address_components", "geometry", "icon", "adr_address"],
      componentRestrictions: { country: ["NZ", "AU"] },
    })
    autocomplete.addListener("place_changed", () => {
      const places = autocomplete.getPlace()
      const lat = places.geometry?.location?.lat()
      const lng = places.geometry?.location?.lng()

      if (lat && lng) {
        this.currentCenter = new google.maps.LatLng(lat, lng)
        this.sortMarkers(this.currentCenter, this.radius)
      }
    })
  },
  setHtml() {
    if (this.impMarkers) {
      let impHtml = ""
      this.impMarkers.forEach((item) => {
        impHtml += this.html(item)
      })
      this.impStoresHTML.innerHTML = impHtml
    }
    if (this.regularMarkers) {
      let Html = ""
      this.regularMarkers.forEach((item) => {
        Html += this.html(item)
      })
      this.storesHTML.innerHTML = Html
    }
  },
  getBrandsImages(brandsId: string) {
    const ids = brandsId.split(",")
    let html = ""
    this.brands.forEach((item) => {
      if (ids.includes(item.id)) {
        html += `<img src="${item.img}" alt="">`
      }
    })
    return html
  },
  getServicesList(servicesId: string) {
    const ids = servicesId.split(",")
    let html = ""
    let i = 0
    this.services.forEach((item) => {
      if (ids.includes(item.id)) {
        html += `${i !== 0 ? "<span>,</span>&nbsp;" : ""}${item.name}`
        i++
      }
    })
    return html
  },

  html(item: { [key: string]: string }) {
    return `
        <div class="single-store">
            <div class="single-store__header">
                <div class="single-store__header-wrap">
                    <p class="single-store__text">${item.name} - ${item.distance}Km From You</p>
                  ${
                    item.highPr === "y"
                      ? `<p class="single-store__text">
                        <svg class="" target="_blank">
                          <use xlink:href="#circle-check-light"></use>
                        </svg>
                        Highest Qualified
                    </p>   
                   `
                      : ""
                  }
              </div>
            </div>
            <div class="single-store__main">
                <h2 class="single-store__title">${item.name}</h2>
                <div class="single-store__main-info">
                    <p class="single-store__text">Phone: <a href="tel:${item.phone}">${item.phone}</a></p>
                    ${item.url ? `<p class="single-store__text">Website: <a href="https://${item.url}" target="_blank">${item.url}</a></p>` : ""}
                </div>
            </div>
            <div class="single-store__img-wrap">
                ${this.getBrandsImages(item.brands)}
            </div>
            <div class="single-store__text-wrap">           
                <div class="single-store__main-info">
                    <p class="single-store__text"><b>Address:</b></p>
                    <p class="single-store__text"> ${item.street1 ? item.street1 + "," : ""}  ${item.street2 ? item.street2 + "," : ""} ${item.city}  ${item.state} ${item.zip}</p>
                </div>
            </div>
            <div class="single-store__text-wrap">           
                <div class="single-store__main-info">
                    <p class="single-store__text"><b>Services:</b></p>
                    <p class="single-store__text">${this.getServicesList(item.services)}</p>
                </div>
            </div>
        </div>`
  },
}

export default storefinder
